import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPauseCircleOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			d: "M0 0L16 0 16 16 0 16z",
			transform: "translate(-1184 -984) translate(0 960) translate(1168 14) translate(16 10)"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#03A9F4",
			fillRule: "nonzero",
			d: "M5.6 11.2h1.6V4.8H5.6v6.4zM8 0C3.584 0 0 3.584 0 8s3.584 8 8 8 8-3.584 8-8-3.584-8-8-8zm0 14.4c-3.528 0-6.4-2.872-6.4-6.4 0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4zm.8-3.2h1.6V4.8H8.8v6.4z",
			transform: "translate(-1184 -984) translate(0 960) translate(1168 14) translate(16 10)"
		})] }) }) }) })
	})
});
export default SvgPauseCircleOutline;
